import React, { useContext } from "react";
import { NotificationContext } from "../Context/NotificationContext";

const NotificationPopup = () => {
  const { popups, dismissPopup } = useContext(NotificationContext);

  if (!popups || popups.length === 0) return null;

  return (
    <div style={containerStyle} aria-live="polite">
      {popups.map((p) => (
        <div key={p._id} style={cardStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
            <div>
              <strong style={{ fontSize: 14 }}>{p.title}</strong>
              <div style={{ fontSize: 13, marginTop: 6 }}>{p.message}</div>
              <div style={{ fontSize: 11, marginTop: 8, color: "#666" }}>
                {new Date(p.createdAt).toLocaleString()}
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              <button
                onClick={() => dismissPopup(p._id, true)}
                style={dismissBtnStyle}
                title="Dismiss & mark read"
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const containerStyle = {
  position: "fixed",
  top: 16,
  right: 16,
  zIndex: 9999,
  display: "flex",
  flexDirection: "column",
  gap: 10,
  maxWidth: 360,
};

const cardStyle = {
  background: "white",
  border: "1px solid rgba(0,0,0,0.08)",
  boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
  padding: 12,
  borderRadius: 8,
};

const dismissBtnStyle = {
  background: "#e9ecef",
  border: "none",
  padding: "6px 10px",
  borderRadius: 6,
  cursor: "pointer",
};

export default NotificationPopup;
